const de =
{
  'Language Key': 'de',
  'cui-org-info': 'Organisation Info',
  'cui-sign-on-info': 'Melden Sie auf Info',
  'cui-user-info': 'Benutzerinformation',
  'cui-preferences': 'Voreinstellungen',
  'cui-review': 'Rezension',
  'cui-org': 'Organisation',
  'cui-company-division': 'Unternehmensbereich',
  'cui-org-address': 'Organisation Anschrift',
  'cui-user-address': 'Benutzeradresse',
  'cui-country': 'Land',
  'cui-city': 'Stadt',
  'cui-state': 'Staat / Provinz',
  'cui-postal': 'Postleitzahl',
  'cui-user-id': 'Benutzeridentifikation',
  'cui-password': 'Passwort',
  'cui-password-re': 'Kennwort erneut eingeben',
  'cui-challenge-question': 'Sicherheitsfrage',
  'cui-challenge-answer': 'Challenge-Antwort',
  'cui-favorite-pet-q': 'Was ist dein Lieblings Namen des Haustieres?',
  'cui-mother-q': 'Was ist der Mädchenname Ihrer Mutter?',
  'cui-best-friend-q': 'Wer ist dein bester Freund?',
  'cui-first-name': 'Vorname',
  'cui-last-name': 'Familienname, Nachname',
  'cui-email': 'Email',
  'cui-email-re': 'Erneut eingeben E-Mail',
  'cui-telephone': 'Telefonnummer',
  'cui-timezone': 'Zeitzone',
  'cui-submit': 'EINREICHEN',
  'cui-next': 'NÄCHSTER SCHRITT',
  'cui-previous': 'BISHERIGE',
  'cui-create-security-admin-account': 'Erstellen Sie Ihr Sicherheitsadministratorkonto',
  'cui-skip-for-now': 'FÜR JETZT ÜBERSPRINGEN',
  'icon-library': 'Icon Library',
  'cui-new-TLO': 'Neue Top-Level-Organisation',
  'cui-new-TLO-description': 'Wählen Sie diese Methode, wenn Sie die Covisint Exchange als neue Covisint Organisation beitreten wollen',
  'cui-new-division': 'neue Abteilung',
  'cui-new-division-description-start': 'Wählen Sie diese Methode, wenn Sie möchten, dass das werden',
  'cui-new-division-description-end': 'einer neuen Abteilung innerhalb einer bestehenden Organisation Covisint.',
  'cui-security-administrator': 'Security Administrator',
  'cui-new-user': 'Neuer Benutzer',
  'cui-new-user-description': 'Wählen Sie diese Methode, wenn Sie einen Mitarbeiter eines bestehenden Covisint Mitglied Unternehmen versuchen, Zugriff auf eine Anwendung Ihrer Organisation abonniert sind oder wenn Sie nicht sicher sind, ob Ihre Organisation registriert ist.',
  'cui-sign-up': 'Anmelden',
  'cui-address': 'Adresse',
  'cui-organization-name': 'Unternehmensbereich',
  'cui-supplier-code': 'Lieferantencode',
  'cui-address-1': 'Adresse 1',
  'cui-address-2': 'Adresse 2',
  'cui-user-information': 'Nutzerinformation',
  'cui-organization-information': 'Informationen über Ihre Organisation',
  'cui-sign-in-information': 'Anmelden Informationen',
  'cui-package-selection': 'Paketauswahl',
  'cui-welcome-popover': 'Zu den Aufgaben des Security Administrator im Detail erläutert werden, nachdem Sie eine Registrierungsmethode auswählen. Sie können jedoch wählen Sie Ihre Registrierung, um stornieren ein anderes Mitglied Ihrer Organiziation zu ermöglichen, wie der Security Administrator zu registrieren.',
  'create-account': 'Erstelle deinen Account',
  'cui-agree-covisint': 'Ich stimme der Covisint',
  'terms-of-service': 'Nutzungsbedingungen',
  'cui-and': 'und',
  'privacy-policy': 'Datenschutz-Bestimmungen',
  'cui-tos-agree': 'Sie müssen den Nutzungsbedingungen zustimmen, um fortzufahren.',
  'cui-user-profile': 'Benutzerprofil',
  'cui-my-profile': 'Mein Profil',
  'cui-login': 'Anmeldung',
  'cui-supplier-content': 'Aktualisieren Sie diese, sobald die Design-Dokumentation in kommen. Dies ist in der Übersetzung google doc. Lorem Ipsum. Andere Sachen. Lieferantennummer wichtige Informationen. Ich mag Schildkröten.',
  'cui-all-organizations': 'Alle Organisationen:',
  'cui-application-select-info': 'Sie können jederzeit Ihre Auswahl treffen, nachdem zum ersten Mal in der Anmeldung.',
  'cui-all-applications': 'Alle Anwendungen',
  'cui-page-not-found': 'Seite nicht gefunden',
  'cui-page-not-found-content': 'Die Seite, die Sie suchen, könnte gelöscht wurden oder nie existiert haben.',
  'cui-home': 'ZUHAUSE',
  'cui-access-denied': 'Zugriff abgelehnt',
  'cui-access-denied-content': 'Sie sind nicht zu sehen diese Seite autorisiert.',
  'cui-registration-status': 'Registrationsstatus',
  'cui-pending-status': 'Offener Status',
  'cui-pending-status-content': 'Ihr Registrierungsstatus steht noch aus. Sie werden in Kürze eine E-Mail mit mehr Details.',
  'cui-thank-you': 'Vielen Dank',
  'cui-request-submitted': 'Anfrage eingereicht',
  'cui-success': 'Erfolg',
  'cui-success-content': 'Ihre Covisint Registrierung wurde erfolgreich abgegeben. Sie werden in Kürze eine E-Mail mit mehr Details.',
  'cui-check-your': 'Überprüfe dein',
  'cui-registration-status-lower': 'Registrationsstatus',
  'cui-application-selection': 'Applikationsauswahl',
  'cui-applications': 'Anwendungen',
  'cui-profile-settings': 'Profileinstellungen',
  'cui-name': 'Name',
  'cui-update': 'Aktualisieren',
  'cui-updated': 'Aktualisiert',
  'cui-error-try-again': 'Error! Versuch es noch einmal?',
  'cui-back': 'Zurück',
  'cui-selections': 'Auswahl',
  'cui-add-org': 'In Organisation',
  'cui-remove-org': 'entfernen Organisation',
  'cui-select-org': 'wählen Sie Organisation',
  'cui-more-information': 'Mehr Informationen',
  'cui-inv-user-popover-info': 'Aus Sicherheitsgründen müssen Sie sich mit der E-Mail registrieren Sie wurden gesendet einladen. Dies kann innerhalb von Benutzereinstellungen bearbeitet werden, wenn die Registrierung abgeschlossen ist.',
  'cui-org-profile': 'Unternehmensprofil',
  'cui-info': 'Info',
  'cui-admins': 'Admins',
  'lowercase-not-allowed': 'haben alle Kleinbuchstaben nicht',
  'uppercase-not-allowed': 'haben keine Großbuchstaben nicht',
  'numbers-not-allowed': 'haben noch keine Zahlen',
  'special-not-allowed': 'haben keine Sonderzeichen (zB: * +)',
  'chars-not-allowed': 'darf keine der folgenden Zeichen enthalten: {{disallowedChars}}',
  'words-not-allowed': 'darf folgende Wörter nicht enthalten:{{disallowedWords}}',
  'password-length': 'muss zwischen {{min}}-{{max}} Zeichen enthalten',
  'password-rules': 'muss {{requiredNumberOfCharClasses}} der folgenden enthalten:',
  'password-lowercase': 'mindestens 1 Kleinbuchstabe',
  'password-uppercase': 'mindestens 1 Großbuchstaben',
  'password-number': 'mindestens 1 Anzahl',
  'password-special': 'mindestens 1 Sonderzeichen (zB: * +)',
  'passwords-must': 'Passwörter müssen:',
  'welcome-title': 'Registrieren Sie sich für eine der folgenden',
  'cui-application-name': 'Anwendungsname',
  'cui-application-tos': 'Bewertung Allgemeine Geschäftsbedingungen',
  'cui-application-tos-agreement': 'Allgemeine Geschäftsbedingungen Vereinbarung',
  'cui-package-tos': 'Sie haben keine Bedingungen für die ausgewählten Pakete akzeptiert.',
  'cui-view-tos': 'Ansicht Allgemeine Geschäftsbedingungen',
  'password-mismatch': 'Die Passwörter müssen übereinstimmen',
  'cui-back-to-review': 'Zurück zu bewerten',
  'email-mismatch': 'E-Mails müssen übereinstimmen',
  'no-applications-selected': 'Sie haben noch keine Anwendungen ausgewählt. Klicken Sie hier, um zurück zur Anwendungsauswahl zu gehen.',
  'cui-all-fields-required': 'alle Felder sind erforderlich',
  'cui-complete-registration': 'Füllen Sie Ihre Anmeldung unter mit',
  'cui-registered': 'Eingetragen',
  'cui-open': 'Öffnen',
  'cui-close': 'Schließen',
  'cui-street-address': 'Adresse',
  'cui-zip': 'Postleitzahl',
  'cui-language': 'Sprache',
  'cui-phone-main': 'Main',
  'cui-phone-office': 'Büro',
  'cui-phone-fax': 'Telefon / Fax',
  'cui-phone-mobile': 'Handy, Mobiltelefon',
  'cui-save': 'sparen',
  'cui-cancel': 'Stornieren',
  'cui-edit': 'Bearbeiten',
  'cui-phone': 'Telefon',
  'search-by-app-name': 'Suche nach Anwendungsnamen',
  'new-request': 'Neue Anfrage',
  'select-applications': 'Wählen Sie Anwendungen',
  'browse-applications': 'Durchsuchen Anwendungen',
  'go': 'Gehen',
  'filter-list': 'Filterliste',
  'filter': 'Filter',
  'owning-org': 'Owning Org',
  'my-applications': 'meine Anwendungen',
  'app-summary': 'App Zusammenfassung',
  'granted': 'Gewährt',
  'bundled-applications': 'gebündelte Anwendungen',
  'application-details': 'Anwendungsdetails',
  'my-claims': 'Meine Ansprüche',
  'related-applications': 'Verwandte Anwendungen',
  'review-request': 'Überprüfungsantrag',
  'back-to-search': 'Zurück zur Suche',
  'requested-items': 'Angeforderte Artikel',
  'request-reason': 'Grund der Anfrage',
  'reason-im-requesting': 'Grund, warum ich anfordernden',
  'you-must-enter-a-reason': 'Sie müssen einen Grund geben Sie diese App beantragen',
  'cui-org-no-applications': 'Scheint, wie Ihre Organisation alle Anwendungen, die nicht existiert. Sie können immer wieder versuchen, nach der Anmeldung.',
  'cui-filter-org-name': 'Filter nach den Namen der Organisation',
  'cui-address-example': 'Apt, Suite, Bldg. (wahlweise)',
  'cui-filter-app-name': 'Filter nach Anwendungsnamen',
  'cui-search-user-name': 'Suche Benutzer nach Name',
  'page': 'Seite',
  'cui-num-results-page': 'Ergebnisse pro Seite',
  'submit-request': 'Anfrage einreichen',
  'categories': 'Kategorien',
  'cui-answer': 'Antworten',
  'cui-enter-password': 'Passwort eingeben',
  'cui-enter-new-password': 'Neues Passwort eingeben',
  'cui-re-enter-new-password': 'neues Passwort erneut eingeben',
  'granted-to-my-org': 'Zugegeben meine Organisation',
  'collected-items-for-request': 'Gesammelte Artikel für Antrag',
  'cui-invalid-password': 'Ungültiges Passwort. Bitte versuche es erneut.',
  'cui-faq': 'FAQ',
  'cui-frequently-asked-questions': 'Häufig gestellte Fragen',
  'cui-admin-tools': 'Admin tools',
  'cui-this-field-is-required': 'Dieses Feld wird benötigt.',
  'cui-this-field-needs-to-be-longer': 'Dieses Feld muss nicht mehr sein.',
  'cui-you-need-to-agree-to-toc': 'Sie müssen den Nutzungsbedingungen zustimmen, bevor Sie fortfahren.',
  'cui-this-is-not-valid-email': 'Dies ist keine gültige E-Mail.',
  'cui-my-app-requests': 'Meine Anwendung Anfragen',
  'cui-no-claims': 'Sie haben keine Ansprüche für diese Anwendung.',
  'cui-no-details': 'Derzeit keine Details verfügbar.',
  'request': 'Anfordern',
  'all': 'Alle',
  'no-selected-apps': 'Sie haben keine Anwendungen ausgewählt.',
  'basic-info': 'Grundinformation',
  'cui-error-username-exists': 'Benutzer-ID existiert bereits! Bitte wählen Sie eine andere.',
  'password-reset': 'Passwort zurücksetzen',
  'current-password': 'Aktuelles Passwort',
  'timezone-and-language': 'Zeitzone und Sprache',
  'challenge-questions': 'Challenge-Fragen',
  'security-question-repeated': 'Diese Antwort wird bereits verwendet.',
  'cui-by-date-added': 'Datum hinzugefügt',
  'cui-alphabetically': 'Alphabetisch',
  'active': 'Aktiv',
  'pending': 'steht aus',
  'suspended': 'Suspendiert',
  'title': 'Titel',
  'id': 'ICH WÜRDE',
  'url': 'URL',
  'privacy-terms': 'Datenschutz',
  'help': 'Hilfe',
  'cui-learn-more-start': 'Mehr erfahren',
  'cui-learn-more-end': 'darüber, warum wir nach diesen Informationen fragen',
  'cui-org-hierarchy': 'Organisationshierarchie',
  'directory': 'Verzeichnis',
  'userID': 'Benutzeridentifikation',
  'status': 'Status',
  'locked': 'Verschlossen',
  'rejected': 'Abgelehnt',
  'removed': 'entfernt',
  'sort': 'Sortieren',
  'refine': 'Verfeinern',
  'or': 'Oder',
  'organizations': 'Organisationen',
  'roles': 'Rollen',
  'organization-applications': 'Organisation Anwendungen',
  'unactivated': 'Unaktivierte',
  'log-out': 'Ausloggen',
  'welcome': 'Herzlich willkommen',
  'privacy': 'Privatsphäre',
  'terms': 'Bedingungen',
  'user': 'Benutzer',
  'top-level-orgs': 'Top-Level-Organisationen',
  'invite-user': 'Benutzer einladen',
  'invite-division': 'einladen Abteilung',
  'username': 'Nutzername',
  'move': 'Bewegung',
  'no-bundled-or-related': 'Keine gebündelt oder Apps bezogen.',
  'cui-continue': 'Fortsetzen',
  'cui-no-org-divisions': 'Keine Organisation Divisionen',
  'inactive': 'Inaktiv',
  'deny': 'Verweigern',
  'approve': 'Genehmigen',
  'pending-request': 'Ausstehende Anfrage',
  'review-approvals': 'Bewertung Zulassungen',
  'cui-package-no-claims': 'Dieses Paket enthält keine Forderungen',
  'claims': 'Ansprüche',
  'package-name': 'Paketnamen',
  'submit-approvals': 'Senden Zulassungen',
  'view-details': 'Details anzeigen',
  'request-date': 'Anforderungsdatum',
  'registration-decision': 'Anmeldung Entscheidung',
  'requested': 'Angeforderte',
  'getting-user-info': 'Wie Sie Ihre Benutzerinformationen ...',
  'approvals-submitted': 'Zulassungen eingereicht',
  'rejection-submitted': 'Ablehnung eingereicht',
  'approval-summary': 'Approval Zusammenfassung',
  'approved-items': 'genehmigt Artikel',
  'rejected-items': 'abgelehnt Artikel',
  'registration-request-approved': 'Genehmigt Registrierungsanfrage',
  'registration-request-rejected': 'Abgelehnt Registrierungsanforderung',
  'no-items-rejected': 'Keine Artikel abgelehnt',
  'no-items-approved': 'Keine Artikel genehmigt',
  'registration-request': 'Anmeldung anfordern',
  'custom-api-loading': 'Initialisieren der App ...',
  'new-grant': 'Grant-App',
  'search-by-package-name': 'Suche nach Paketnamen',
  'search': 'Suche',
  'administartor-?': 'Administrator?',
  'submit-grant-update': 'Senden Erteilung Update',
  'review-user-pending-approval': 'Kritik User Ausstehende Genehmigung',
  'view-request-for': 'Ansicht Antrag auf',
  'job-title': 'Berufsbezeichnung',
  'query': 'Abfrage',
  'suspend-app': 'Suspend App',
  'new-grants': 'New Grants',
  'update-grant-settings': 'Update Grant-Einstellungen',
  'assign-new-grant-to': 'Weisen Sie neuen Zuschuss',
  'division': 'Aufteilung',
  'redirecting-to-sso': 'Anfordern Ihre Zugangsdaten',
  'included-applications': 'Enthaltene Applikationen',
  'selected-sub-packages': 'Ausgewählte Teilpakete',
  'specify-password': 'Geben Sie das Kennwort',
  'suspend': 'Aussetzen',
  'reset-password': 'Passwort zurücksetzen',
  'confirm-password-reset': 'Sind Sie sicher, dass Sie das Kennwort für diesen Benutzer zurücksetzen?',
  'yes': 'Ja',
  'within': 'innerhalb',
  'search-within': 'In ... suchen',
  'in-your-org': 'in Ihrem org',
  'people': 'Menschen',
  'revoke-package': 'widerrufen Package',
  'cui-by-username': 'Nutzername',
  'cui-by-status': 'Status',
  'cool-got-it': 'Cool, habe es',
  'organization-directory': 'Organisationsverzeichnis',
  'org-nav-invite-links': 'Organisation Navigation und Einladung Verbindungen',
  'org-dir-filters': 'Organization Directory Filter',
  'org-dir-list': 'Organisation Verzeichnisliste',
  'apps': 'Apps',
  'apps-upper': 'APPS',
  'history-upper': 'GESCHICHTE',
  'profile-upper': 'PROFIL',
  'roles-upper': 'ROLLEN',
  'your-app-request-in-review': 'Ihre Bewerbung Antrag wurde eingereicht',
  'error-generic': 'Es gab ein Problem Daten auf dieser Seite geladen werden. Bitte versuche es erneut.',
  'cui-application-administrator': 'verfügt derzeit nicht über die Rolle des Anwendungsadministrator, die zugeordnet werden müssen, bevor eine Benutzerverwaltungsrechte für eine bestimmte Anwendung erteilt werden kann. Dies ist eine Zeiteinstellung.',
  'cui-assign-confirm': 'Würden Sie diese Rolle wie jetzt zuweisen?',
  'cui-suspend-warning': 'wird nicht in der Lage, diese Anwendung zugreifen',
  'cui-suspend-confirm': 'Sind Sie sicher, dass Sie möchten, dass jetzt auszusetzen?',
  'cui-notify-user': 'Benutzer benachrichtigen',
  'cui-users': 'Benutzer',
  'cui-no': 'Nein',
  'cui-remove': 'entfernt',
  'cui-org-abbrev': 'Org',
  'cui-userProfile-user-error': 'Es gab einen Fehler Benutzerdaten abgerufen werden. Bitte versuche es erneut.',
  'cui-userProfile-security-error': 'Es gab einen Fehler Abrufen von Sicherheitsfrage Daten. Bitte versuche es erneut.',
  'cui-userProfile-password-error': 'Es gab einen Fehler Kennwortrichtlinie Abrufen von Daten. Bitte versuche es erneut.',
  'cui-suspend-success': 'Diese Anwendung wird nun von dem ausgewählten Benutzer suspendiert',
  'cui-unlock': 'Freischalten',
  'cui-unlock-password-confirm': 'Sind Sie sicher, dass Sie möchten, um dieses Kennwort des Benutzers entsperren?',
  'cui-error-unlocking-password': 'Sorry, es war ein Fehler dieses Benutzers Passwort entsperren.',
  'cui-error-person-request': 'Unfähig Registrierungsanforderung Daten für diesen Benutzer abzurufen.',
  'cui-error-email-exists': 'E-Mail-Adresse bereits vergeben ist',
  'cui-password-history-rule': 'alle Ihre vorherigen nicht übereinstimmen {{}} numberOfPasswords Passwörter',
  'cui-password-policy': 'Kennwortrichtlinie',
  'cui-security-admin': 'Sicherheitsadministratoren',
  'cui-button-loading-text': 'Wird geladen...',
  'cui-username-taken': 'Benutzername ist vergeben',
  'cui-no-applications': 'Sie haben zur Zeit keine Anwendungen',
  'cui-mask-answers': 'Maske / Unmask Sicherheit Antworten',
  'cui-pwd-reset-success': 'Kennwort zurücksetzen Erfolg!',
  'cui-last-login': 'Letzte Anmeldung',
  'cui-need-different-app': 'Benötigen Sie eine andere Anwendung',
  'cui-go-back-to': 'Geh zurück zu',
  'cui-tos-applications': 'Bitte akzeptieren Allgemeine Geschäftsbedingungen für die ausgewählten Anwendungen',
  'cui-selected-apps': 'ausgewählte Anwendungen',
  'cui-authentication-policy': 'Authentication Policy',
  'cui-selected': 'Ausgewählt',
  'cui-tac': 'Geschäftsbedingungen',
  'cui-accept': 'Akzeptieren',
  'cui-tac-agree': 'Sie müssen mit den Nutzungsbedingungen zustimmen, um fortzufahren.',
  'cui-printer-friendly-tac': 'Drucker-optimierte Geschäftsbedingungen',
  'cui-my-history': 'Meine Geschichte',
  'cui-status-history': 'Mein Status Geschichte',
  'cui-app-history': 'Anwendungsgeschichte',
  'cui-password-change-log': 'Kennwort Änderungsprotokoll',
  'cui-date': 'Datum',
  'cui-event-type': 'Ereignistyp',
  'cui-action-by': 'Aktion Ausgeführte durch',
  'cui-notes': 'Anmerkungen',
  'cui-try-again': 'Bitte versuche es erneut.',
  'cui-password-change-log-error': 'Es gab einen Fehler Abrufen Passwort Änderungsprotokoll.',
  'cui-userstatus-history-error': 'Es gab einen Fehler Abrufen von Benutzerstatushistorie.',
  'cui-claims-error': 'Es ist ein Fehler Abrufen Ansprüche.',
  'cui-org-app-suspend-success': 'Diese Anwendung wird nun aus den ausgewählten Organisationen, alle Benutzer und alle Unterorganisationen ausgesetzt.',
  'cui-org-app-suspend-msg1': 'Durch diese Aktion wird die Aktion von allen Benutzern und Unterorganisationen, auch wenn im aktiven Gebrauch suspendieren.',
  'cui-org-app-suspend-msg2': 'Sind Sie sicher, dass Sie suspendieren',
  'cui-from': 'von',
  'cui-application-granted-history': 'Anmeldung Erteilung Geschichte',
  'cui-application-requested-history': 'Anwendung Anfrage Historie',
  'approved': 'Genehmigt',
  'decision': 'Entscheidung',
  'evaluator': 'Evaluator',
  'action': 'Aktion',
  'cui-invalid-invitation': 'Einladung wird entweder bereits verwendet oder ungültig',
  'cui-by-request-date': 'Anforderungsdatum',
  'cui-by-decision-date': 'Entscheidungstag',
  'cui-no-orgs-for-name': 'Keine Organisationen für den angegebenen Namen gefunden. Bitte versuchen Sie es mit einem anderen Namen.',
  'requests': 'Anfragen',
  'no-pending-apps': 'Sie haben keine ausstehenden Anwendungsanforderungen.',
  'description': 'Beschreibung',
  'launch': 'Starten',
  'manage-applications': 'Anwendungen verwalten',
  'request-type': 'Anfragetyp',
  'phase': 'Phase',
  'date-submitted': 'Date Submitted',
  'cui-pending-requests-error': 'Es gab einen Fehler beim Abrufen / Aktualisieren von Anfragen.',
  'no-requests-by-name': 'Keine Anfragen für den angegebenen Namen gefunden. Bitte versuchen Sie es mit einem anderen Namen.',
  'cannot-change-password': 'Kann nicht das Kennwort jetzt ändern',
  'select-claims': 'auswählen Ansprüche',
  'grant-reason': 'Grant-Grund',
  'grants-assigned': 'New Grants Assigned',
  'suspend-error': 'Es gab einen Fehler in Anfragen zu suspendieren.',
  'unsuspend-error': 'Es gab einen Fehler in Unsuspend Anfragen.',
  'approval': 'Die Genehmigung',
  'administrator': 'Administrator',
  'submitted': 'eingereicht',
  'no-bundled': 'Keine gebündelten Anwendungen',
  'disallowed-password-rule': 'Kann kein Wort auf der nicht anerkannten Wörter Liste enthalten',
  'request-approve-or-rejected': 'Diese Anforderung wird entweder genehmigt / abgelehnt',
  'application': 'Anwendung',
  'show-all': 'Zeige alles',
  'cui-subject': 'Gegenstand',
  'cui-es': '(Es)',
  'cui-invite-user': 'Laden Sie einen Benutzer innerhalb',
  'cui-invite-user-success': 'Ihre Anfrage Benutzer Einladung gesendet',
  'cui-email-recipt': 'Geben Sie E-Mail-Empfänger (trennt mehr mit Komma)',
  'cui-invite-verbiage': 'Laden Sie für eine der folgenden',
  'select': 'Wählen',
  'change-org': 'ändern Org',
  'cui-invite-user-sub': 'Registrieren Sie sich als ein Benutzer beitreten',
  'cui-invite-user-select': 'Suche nach einem org',
  'cui-send-invitation': 'Einladung senden',
  'invite': 'Einladen',
  'cui-invite-tlo-success': 'Ihre Top-Level-Organisation Einladungsanfrage gesendet',
  'cui-invite-tlo': 'Laden Sie eine neue Organisation',
  'cui-invite-division-success': 'Ihre Firma Einladungsanfrage gesendet',
  'cui-invite-division': 'Laden Sie eine Organisation',
  'cui-tlo-sub': 'Registrieren Sie sich als neue Organisation',
  'cui-division-sub': 'Melden Sie sich als Administrator innerhalb',
  'search-by-org-name': 'Suchen nach den Namen der Organisation',
  'app-approval-error': 'Es gab einen Fehler App-Anfragen bei der Genehmigung.',
  'modify-claims': 'ändern Ansprüchen',
  'unsuspend-app': 'Unsuspend App',
  'remove-app': 'App entfernen',
  'user-details': 'Nutzerdetails',
  'reason': 'Grund',
  'required': 'Erforderlich',
  'cui-unsuspend-confirm': 'Sind Sie sicher, dass Sie möchten, dass jetzt entsperren?',
  'unsuspend': 'Unsuspend',
  'remove-confirm': 'Sind Sie sicher, dass Sie möchten, dass jetzt entfernen?',
  'remove': 'Löschen',
  'my-organization': 'Meine Organisation',
  'request-app': 'Anfrage App',
  'no-apps-found': 'Keine Anwendungen gefunden.',
  'refine-search': 'Bitte verfeinern Sie Ihre Suchkriterien ein.',
  'your-assign-role-success': 'Neue Rolle zugewiesen',
  'cui-assigned-roles': 'Zugewiesene Rollen',
  'cui-available-roles': 'Verfügbare Rollen',
  'cui-browse-by-category': 'nach Kategorien durchsuchen',
  'cui-back-navigation-requests': 'Zurück Navigation und Gesuche',
  'cui-search-results': 'Suchergebnisse',
  'cui-new-grant-search-results': 'Neues Finanzhilfesucher',
  'cui-username-close': 'Benutzernamen und schließen Navigation',
  'cui-user-no-apps': 'Nutzer hat keine Anwendungen',
  'cui-no-roles-assigned': 'Dieser Benutzer hat keine zugewiesenen Rollen.',
  'status-history': 'Statushistorie',
  'cui-no-status-history': 'Dieser Benutzer hat keine Statushistorie.',
  'cui-pwd-reset-msg1': 'Password Reset ist erfolgreich. Neues Passwort ist:',
  'cui-pwd-reset-msg2': 'Hinweis: Wenn Sie nur die erste Hälfte Passwort dann die zweite Hälfte Passwort zu sehen, wird den Benutzern E-Mail registriert gesendet werden.',
  'users-upper': 'NUTZER',
  'hierarchy-upper': 'HIERARCHIE',
  'privileges': 'Privilegien',
  'expand-all': 'Alle erweitern',
  'collapse-all': 'Alles schließen',
  'no-records': 'Keine Aufzeichnungen gefunden.',
  'contact-us': 'Kontaktiere uns',
  'cui-error-organization-request': 'Unfähig Registrierungsanforderung Daten für diese Organisation abzurufen.',
  'cui-error-organization-app-request': 'Unfähig App Anforderungsdaten für diese Organisation abzurufen',
  'cui-error-user-app-request': 'Unfähig App Anforderungsdaten für diesen Benutzer abrufen',
  'assign': 'Zuordnen',
  'search-by-person-name': 'Suche nach Personennamen',
  'grant-history': 'Geschichtlich Grant',
  'request-history': 'Anfrage Historie',
  'social-login': 'Social Login',
  'facebook': 'Facebook',
  'twitter': 'zwitschern',
  'link': 'Verknüpfung',
  'unlink': 'unlink',
  'invalid-url': 'Dies ist keine gültige URL.',
  'linkedin': 'LinkedIn',
  'google': 'Google',
  'administration': 'Verwaltung',
  'services': 'Dienstleistungen',
  'n-phase': 'N - Phase Zulassung',
  'edit-package': 'Paket bearbeiten',
  'is-requestable': 'ist Auf Anfrage erhältlich',
  'is-displayable': 'ist Anzeigbare',
  'is-grantable': 'ist erfüllbar',
  'require': 'Benötigen',
  'is-requestable-desc': 'Geben Sie, wenn der Benutzer diese Anwendung anfordern können.',
  'is-grantable-desc': 'Geben Sie, wenn diese Anwendung direkt von der Firma Verabreichung an den Benutzer erteilt werden kann',
  'is-displayable-desc': 'Geben Sie, wenn das Paket-Symbol auf My Applications Seite angezeigt werden sollen',
  'require-reason-desc': 'Geben Sie, wenn dieses Paket den Benutzer erforderlich, um einen Grund für die Beantragung dieses Paket zu liefern',
  'company-admin': 'Unternehmen Admin',
  'application-admin': 'Anwendung Admin',
  'company-admin-desc': 'Dies ist die Standardgenehmigungsphase, sollte es ja sein, wenn es keine andere Phase ist erforderlich',
  'application-admin-desc': 'Hat der Benutzer Anwendungsanforderung durch die Anwendung Administrator genehmigt werden muss?',
  'add-admins': 'hinzufügen von Administratoren',
  'cardinality-indicator': 'Cardinality Indicator',
  'cui-one': 'Ein',
  'cui-many': 'Viele',
  'claim-values': 'Anspruch Values',
  'cui-add': 'Hinzufügen',
  'cui-view': 'Aussicht',
  'cui-claim': 'Anspruch',
  'cui-category': 'Kategorie',
  'cui-service': 'Bedienung',
  'cui-delete': 'Löschen',
  'federation-conn': 'Federation Verbindung',
  'updated-date': 'Neues Datum',
  'target-url': 'Ziel-URL',
  'remote-app-id': 'Remote Application Id',
  'mobile-sso-url': 'Mobile SSO URL',
  'mobile-app-id': 'Mobile App-ID',
  'cui-package': 'Paket',
  'cui-create': 'Erstellen',
  'more-languages': 'mehr Sprachen',
  'duplicate-language-error': 'Doppelte Sprachen sind nicht erlaubt',
  'cui-nextstep': 'Nächster',
  'create-package': 'Paket erstellen',
  'manage-package-claims': 'Verwalten Package Ansprüche',
  'cardinality-indicator-error': 'Cardinality Indikator kann nicht sein',
  'value-id-exists': 'Wert Id existiert bereits',
  'claim-id-exists': 'Anspruch Id existiert bereits',
  'cui-new': 'Neu',
  'package-success-content': 'Das Paket wird erstellt',
  'add-claims': 'In Ansprüche',
  'package-update-success': 'Paket erfolgreich aktualisiert'
}
export {
  de
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/de.js